const TdDayVal = ({ status }) => {
  const i =
    status === 1 ? "fa-check" : status === 2 ? "fa-hourglass-o" : "fa-times";

  return (
    <td className="center" style={{ verticalAlign: "middle" }}>
      <span
        className={
          status === 1
            ? "success"
            : status === 2
            ? "working"
            : status === 0
            ? "error"
            : "invisible"
        }
      >
        <div style={{ fontSize: "1rem", paddingTop: "4px" }}>
          <i className={`fa ${i}`}></i>
        </div>
      </span>
    </td>
  );
};

export default TdDayVal;
